export const Disclaimer = ({
  text,
  icon,
  textColor = '',
}: {
  text: string;
  icon: string;
  textColor?: string;
}) => {
  return (
    <div className="flex items-start mt-4">
      <img src={icon} className="mr-2" />
      <p style={{ color: textColor }} className="text-s-14">
        {text}
      </p>
    </div>
  );
};
